// extracted by mini-css-extract-plugin
module.exports = {"days":"Schedule_days__00dHq","hours":"Schedule_hours__kYouN"};